import { limparCnpj, limparCpfCnpj, TAMANHO_CPF } from "./validarCpfCnpj";

function mCNPJ(cnpj: string): string {
    cnpj = cnpj.replace(/^([0-9A-Za-z]{2})([0-9A-Za-z])/, "$1.$2");
    cnpj = cnpj.replace(/^([0-9A-Za-z]{2})\.([0-9A-Za-z]{3})([0-9A-Za-z])/, "$1.$2.$3");
    cnpj = cnpj.replace(/\.([0-9A-Za-z]{3})([0-9A-Za-z])/, ".$1/$2");
    cnpj = cnpj.replace(/([0-9A-Za-z]{4})([0-9A-Za-z])/, "$1-$2");
    return cnpj;
}

function mCPF(cpf: string): string {
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return cpf;
}

function mCPFCNPJ(valor: string) {
    valor = limparCpfCnpj(valor);
    if (valor.length <= TAMANHO_CPF) {
        return mCPF(valor);
    } else {
        return mCNPJ(valor);
    }
}

export function formatarCnpj(valor: string) {
    return mCNPJ(limparCnpj(valor).slice(0, 14));
}

export function formatarCpfCnpj(valor: string) {

    if (valor.length >= 19) {
        valor = valor.substring(0, valor.length - 1);
    } else {
        valor = mCPFCNPJ(valor);
    }

    return valor;
}
